import { render, staticRenderFns } from "./OptimizedShippingServiceLevels.vue?vue&type=template&id=183d4bcf&scoped=true&"
import script from "./OptimizedShippingServiceLevels.vue?vue&type=script&lang=js&"
export * from "./OptimizedShippingServiceLevels.vue?vue&type=script&lang=js&"
import style0 from "./OptimizedShippingServiceLevels.vue?vue&type=style&index=0&id=183d4bcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d4bcf",
  null
  
)

export default component.exports